module.exports = __webpack_public_path__ + "static/media/stdmgmt.cbc8b8ff.png";